import { render, staticRenderFns } from "./adjektiv-komparation.vue?vue&type=template&id=26b330be&scoped=true"
import script from "./adjektiv-komparation.vue?vue&type=script&lang=js"
export * from "./adjektiv-komparation.vue?vue&type=script&lang=js"
import style0 from "./adjektiv-komparation.vue?vue&type=style&index=0&id=26b330be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b330be",
  null
  
)

export default component.exports